import type { AlertItem, EventItem, NewsItem, QuickLink, Slide } from '../types/content'

/**
 * Visuels à l'échelle du village : phare de Pointe-des-Monts, dépôt de matières
 * résiduelles et scènes de la Côte-Nord, plutôt que des images de grande ville.
 */
const HERO_COLLAGE = 'https://cdn.magicpatterns.com/uploads/1XSBpHnxiDQFUmrpLkkxnH/image.png'
const IMG_A = 'https://cdn.magicpatterns.com/patterns/generated-images/2ef9976a-f50f-4cc2-9ce3-dc04e5ff5f75.jpg'
const IMG_B = 'https://cdn.magicpatterns.com/patterns/generated-images/6cdfd633-9816-44b7-a1b8-b036963e610c.jpg'

export const slides: Slide[] = [
  {
    id: 'app',
    eyebrow: 'Services en ligne',
    title: 'Baie-Trinité dans votre poche avec bciti+',
    date: 'Disponible maintenant',
    description:
      'Collectes, requêtes, avis à la population, permis et baux de villégiature : vos services municipaux dans une seule application.',
    cta: 'Télécharger l’application',
    image: HERO_COLLAGE,
    tone: 'blue',
  },
  {
    id: 'chats',
    eyebrow: 'Avis à la population',
    title: 'Journées de stérilisation de chats errants',
    date: 'Les 25 et 26 septembre 2026',
    description:
      'Deux journées organisées par la Municipalité pour la stérilisation des chats errants du village.',
    cta: 'Lire l’avis',
    image: HERO_COLLAGE,
    tone: 'navy',
  },
]

export const quickLinks: QuickLink[] = [
  { label: 'Mon espace', icon: 'smartphone', to: '/mon-espace' },
  { label: 'Collectes et centre de tri', icon: 'trash', to: '/mes-collectes' },
  { label: 'Compteur d’eau', icon: 'water', to: '/mon-compteur-eau' },
  { label: 'Requêtes et signalements', icon: 'alert', to: '/mes-demandes' },
  { label: 'Permis et certificats', icon: 'permit', to: '/mes-permis' },
  { label: 'Avis à la population', icon: 'bell', to: '/notifications' },
  { label: 'Licences d’animaux', icon: 'pet', to: '/mes-animaux' },
  { label: 'Bibliothèque et loisirs', icon: 'ball', to: '/mes-loisirs' },
]

export const heroPrompts: { label: string; to: string }[] = [
  { label: 'Ma prochaine collecte', to: '/mes-collectes' },
  { label: 'Signaler un bris', to: '/mes-demandes' },
  { label: 'Demander un permis', to: '/mes-permis' },
]

export const alert: AlertItem = {
  level: 'info',
  title: 'Centre de tri fermé le samedi 19 septembre',
  detail: 'Deuxième fermeture du mois, après celle du 12 septembre.',
  body: [
    'Le centre de tri de Baie-Trinité sera fermé le samedi 19 septembre 2026. Il l’était déjà le 12 septembre.',
    'En saison, le centre ouvre tous les samedis de 8 h à 16 h, et celui de Godbout le dimanche qui suit. En hiver, l’ouverture passe à un samedi sur deux. Le centre ferme également lors des tempêtes de neige.',
  ],
  scope: 'Centre de tri de Baie-Trinité · samedi 19 septembre 2026',
}

export const featuredNews: NewsItem = {
  id: 'centre-de-tri-19',
  category: 'Matières résiduelles',
  date: '18 septembre 2026',
  title: 'Petit rappel : le centre de tri sera fermé le samedi 19 septembre',
  excerpt:
    'La Municipalité rappelle que le centre de tri ne sera pas accessible ce samedi. La prochaine ouverture suivra l’horaire habituel du samedi, de 8 h à 16 h.',
  image: IMG_A,
}

export const secondaryNews: NewsItem[] = [
  {
    id: 'chats-errants',
    category: 'Avis à la population',
    date: '17 septembre 2026',
    title: 'Journée de stérilisation de chats errants les 25 et 26 septembre 2026',
    excerpt:
      'Deux journées sont organisées pour la stérilisation des chats errants. Les détails et les modalités d’inscription sont diffusés par la Municipalité.',
    image: IMG_B,
  },
  {
    id: 'activite-19',
    category: 'Vie communautaire',
    date: '15 septembre 2026',
    title: 'Avis à la population : une belle activité pour vous samedi 19 septembre 2026',
    excerpt: 'Une activité communautaire est organisée au village ce samedi.',
  },
  {
    id: 'bureau-ferme',
    category: 'Vie municipale',
    date: '2 septembre 2026',
    title: 'Bureau municipal fermé les 3, 4 et 7 septembre 2026',
    excerpt: 'Le bureau reprend ses heures habituelles à la suite de cette fermeture.',
  },
]

export const events: EventItem[] = [
  {
    id: 'activite-communautaire',
    day: '19',
    month: 'SEPT',
    title: 'Activité communautaire',
    place: 'Baie-Trinité',
    time: 'Samedi',
    tag: 'Communauté',
  },
  {
    id: 'rgmrm',
    day: '22',
    month: 'SEPT',
    title: 'Assemblée de la Régie de gestion des matières résiduelles de la Manicouagan',
    place: 'RGMRM',
    time: 'Public admis dès 11 h',
    tag: 'Matières résiduelles',
  },
  {
    id: 'chats-errants',
    day: '25',
    month: 'SEPT',
    title: 'Journées de stérilisation de chats errants',
    place: 'Baie-Trinité',
    time: 'Les 25 et 26 septembre',
    tag: 'Animaux',
  },
]
